
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/native-trees",
      function () {
        return require("private-next-pages/native-trees/index.page.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/native-trees"])
      });
    }
  